import { render, staticRenderFns } from "./SelectContianer.vue?vue&type=template&id=2d0058af&scoped=true&"
import script from "./SelectContianer.vue?vue&type=script&lang=js&"
export * from "./SelectContianer.vue?vue&type=script&lang=js&"
import style0 from "./SelectContianer.vue?vue&type=style&index=0&id=2d0058af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0058af",
  null
  
)

export default component.exports